/**
 * Practice Org Review API (GDN-2271).
 *
 * The two provider-facing org-review endpoints now ship in the generated
 * data-migration contract (`listOrgReviewPending` / `resolveOrgReviewRow`), so
 * this file only layers cache-tag behaviour on top of the generated api —
 * mirroring `features/patient-import/store/api.ts`. A successful resolve
 * invalidates the list tag, so the item leaves the inbox on refetch and the
 * count-gated practice tab updates.
 */

import { enhancedApi as dataMigrationApi } from '@store/generated/data-migration';

export const orgReviewApi = dataMigrationApi.enhanceEndpoints({
  addTagTypes: ['OrgReviewList'],
  endpoints: {
    listOrgReviewPending: {
      providesTags: [{ type: 'OrgReviewList' as const, id: 'LIST' }],
    },
    resolveOrgReviewRow: {
      invalidatesTags: [{ type: 'OrgReviewList' as const, id: 'LIST' }],
    },
  },
});

export const { useListOrgReviewPendingQuery, useResolveOrgReviewRowMutation } =
  orgReviewApi;
